import React, { useEffect, useRef, useState } from 'react';
import html2canvas from 'html2canvas';
import searchIcon from 'assets/img/search.svg';
import shareIcon from 'assets/img/share-1.svg';
import EditableText from '../shared/EditableText';
import InviteMemberPopup from 'pages/projects/kanban/shared/InviteMember/InviteMemberPopup';
import style from './ProjectBoardHeading.module.css';
import AvatarGroup from '../shared/AvatarGroup';
import SaveModalKanban from 'components/SaveModalKanban';
import SaveIcon2 from 'assets/img/save-icon2.svg';
import boardToast, { TOAST_TYPE } from '../utils/boardToast';
import APIServices from 'services/APIServices';
import { useAuth } from 'contexts/AuthContext';
import { useNavigate, useParams } from 'react-router-dom';
import FilterDropdown from '../shared/FilterDropdown';
import { Dropdown, Modal } from 'react-bootstrap';
import dotsThreeIcon from 'assets/img/DotsThree.svg';
import Board from 'assets/img/board.svg';
import Calender from 'assets/img/calender.svg';
import OverviewIcon from 'assets/img/check-square.svg';
import ArrowLeft from 'assets/img/calender-arrow-left.svg';
import ArrowRight from 'assets/img/calender-arrow-right.svg';
import dotsMenu from 'assets/img/dote-menu.svg';
import Archived from 'assets/img/archived.svg';
import Save01 from 'assets/img/save-01.svg';
import Close4 from 'assets/img/close4.svg';
import editStatus from 'assets/img/edit-status.svg';
import submenuIcon from 'assets/img/submenu-icon.svg';
import ShareNetwork from 'assets/img/ShareNetwork.svg';
import closeIcon from 'assets/img/icon-cross.svg';
import { selectLoader } from 'utils/Helpers';
import AddStatusModal from 'components/AddStatusModal';
import editIcon from 'assets/img/edit-pencil.svg';
import deleteIcon from 'assets/img/delete3.svg';
import DeleteModal from 'components/DeleteModal';

const ProjectBoardHeading = ({
  title,
  handleSubmitTitle,
  teams,
  handleSearchChange,
  inviteTeam,
  handleRemoveInvitee,
  searchValue,
  projectBoardId,
  hideEditButton,
  projectBoardCreatedBy,
  viewMode,
  isInviting = false,
  getBoardNode,
  isTemplateActive,
  fetchTemplates,
  activeTemplateId,
  parentBoardId,
  fetchProjectBoards,
  isGeneralPreview,
  boardViewType,
  setBoardViewType,
  parentRef,
  calendarTitle,
  calenderViewType,
  setCalenderViewType,
  isArchivedActive,
  setShowConfirm,
  isSaving,
  setSearchValue,
  priorityOptions,
  dueDateOptions,
  milestones,
  setMilestones,
  setFilteredMilestones,
  setCalendarDate,
  isMasterCalender,
  defaultLabels,
  reloadMilestones,
  toggleBoardList,
  isBoardListCollapsed,
  calendarEvents,
  setFilteredCalendarEvents,
  setshowArchivedCards,
  isProjectRelatedBoard = false,
  hideTabs = false,
  isArchivedParent = false,
  handleGoogleCalendarExport,
  handleGoogleCalendarDisconnect,
  isGoogleExporting = false,
  isGoogleDisconnecting = false,
  isGoogleCalendarConnected = false,
  onTemplateRenamed = () => {},
  onTemplateDeleted = () => {},
  onUseTemplate = null
}) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [showMembersPopup, setShowMemberPopup] = useState(false);

  const [saveOpen, setSaveOpen] = useState(false);
  const [templateTitle, setTemplateTitle] = useState('');
  const [savingTemplate, setSavingTemplate] = useState(false);
  const [showTemplateEdit, setShowTemplateEdit] = useState(false);
  const [showTemplateDelete, setShowTemplateDelete] = useState(false);
  const [editedTemplateName, setEditedTemplateName] = useState('');
  const [isApplyingTemplate, setIsApplyingTemplate] = useState(false);
  // const [isSaving, setIsSaving] = useState(false);
  const [showInput, setShowInput] = useState(false);
  const targetRef = useRef(null);
  const overlayRef = useRef(null);
  const inputRef = useRef(null);

  const handleOutsideClick = (event) => {
    const clickedOutsideOverlay = !overlayRef.current || !overlayRef.current.contains(event.target);

    const clickedOutsideTarget = !targetRef.current || !targetRef.current.contains(event.target);

    const clickedOutsideInput = !inputRef.current || !inputRef.current.contains(event.target);

    if (clickedOutsideOverlay && clickedOutsideTarget && clickedOutsideInput) {
      setShow(false);
      setShowMemberPopup(false);
      setShowInput(false);
    }
  };
  const handleSaveBoardFromTemp = async (name) => {
    try {
      console.log(parentBoardId, 'parentBoardId');
      setSavingTemplate(true);
      let payload = { name, templateId: activeTemplateId };
      if (!isGeneralPreview) {
        payload.parentBoardId = parentBoardId;
      }
      console.log('Save board from template:', name);
      let response = await APIServices.post(`/project-board/clone-template`, payload);
      console.log(response, 'Response after saving board from template');
      if (response?.message) {
        boardToast(response.message, TOAST_TYPE.SUCCESS);
        if (isGeneralPreview) {
          navigate(`/project-board/${response?.boardId}`, {
            state: {
              isProjectRelatedBoard: false
            }
          });
        } else {
          setSaveOpen(false);
          setTemplateTitle('');
          setSavingTemplate(false);
          fetchProjectBoards(false, response?.boardId);
        }
      } else {
        setSavingTemplate(false);
      }
    } catch (error) {
      console.error('Error saving board from template:', error);
      setSavingTemplate(false);
    }
  };

  const handleSaveTemplate = async (name) => {
    try {
      const boardNode = getBoardNode();
      if (boardNode) {
        setSavingTemplate(true);
        const canvas = await html2canvas(boardNode, { useCORS: true });

        // Convert canvas to Blob instead of base64 string
        canvas.toBlob(async (blob) => {
          if (!blob) {
            console.error('Failed to capture blob from canvas');
            return;
          }

          const formData = new FormData();
          formData.append('name', name);
          formData.append('description', '');
          formData.append('templateImage', blob, 'screenshot.png'); // must pass blob + filename
          formData.append('companyId', user?.companyId?._id || '');

          console.log('FormData content:');
          for (let [key, value] of formData.entries()) {
            console.log(key, value);
          }
          // Make the POST request
          let response = await APIServices.post(`/project-board-templates/${projectBoardId}/save`, formData, {
            'Content-Type': 'multipart/form-data'
          });
          if (response?.message) {
            boardToast(response.message, TOAST_TYPE.SUCCESS);
            setSaveOpen(false);
            setTemplateTitle('');
            setSavingTemplate(false);
          } else {
            setSavingTemplate(false);
          }
        }, 'image/png');
      }
    } catch (err) {
      console.error('Error:', err);
    }
  };

  const openTemplateEdit = () => {
    setEditedTemplateName(title || '');
    setShowTemplateEdit(true);
  };

  const handleTemplateRename = async (event) => {
    event.preventDefault();
    const name = editedTemplateName.trim();
    const previousName = title;
    if (!name || !activeTemplateId) return;

    setShowTemplateEdit(false);
    onTemplateRenamed(name);

    try {
      const response = await APIServices.put(`/project-board-templates/${activeTemplateId}`, { name });
      if (response?.status >= 200 && response?.status < 300) {
        boardToast(response.message || 'Template name updated successfully.', TOAST_TYPE.SUCCESS);
        fetchTemplates?.(1);
      } else {
        onTemplateRenamed(previousName);
        boardToast(response?.data?.error || response?.data?.message || 'Failed to update template.', TOAST_TYPE.ERROR);
      }
    } catch (error) {
      onTemplateRenamed(previousName);
      boardToast(error?.response?.data?.message || 'Failed to update template.', TOAST_TYPE.ERROR);
    }
  };

  const handleTemplateDelete = async () => {
    if (!activeTemplateId) return;

    setShowTemplateDelete(false);
    onTemplateDeleted();

    try {
      const response = await APIServices.put(`/project-board-templates/delete/${activeTemplateId}`);
      if (response?.status >= 200 && response?.status < 300) {
        boardToast(response.message || 'Template deleted successfully.', TOAST_TYPE.SUCCESS);
        fetchTemplates?.(1);
      } else {
        boardToast(response?.data?.error || response?.data?.message || 'Failed to delete template.', TOAST_TYPE.ERROR);
      }
    } catch (error) {
      boardToast(error?.response?.data?.message || 'Failed to delete template.', TOAST_TYPE.ERROR);
    }
  };

  const handleUseTemplateClick = async () => {
    setShow(false);
    setShowMemberPopup(false);

    if (!onUseTemplate) {
      setSaveOpen(true);
      return;
    }

    try {
      setIsApplyingTemplate(true);
      await onUseTemplate(activeTemplateId);
    } finally {
      setIsApplyingTemplate(false);
    }
  };

  const handleIconClick = (val) => {
    setShowInput(val);
    if (val === false) {
      setSearchValue('');
    }
    setTimeout(() => inputRef.current?.focus(), 0); // focus after render
  };

  useEffect(() => {
    setSearchValue('');
    if (!showInput) {
      handleSearchChange('');
    }
  }, [showInput]);

  // Attach event listener for clicks outside
  // useEffect(() => {
  //   if (show || showMembersPopup || showInput) {
  //     document.addEventListener('mousedown', handleOutsideClick);
  //   } else {
  //     document.removeEventListener('mousedown', handleOutsideClick);
  //   }
  //   return () => document.removeEventListener('mousedown', handleOutsideClick);
  // }, [show, showMembersPopup, showInput]);

  return (
    <div className={`${style.heading_wrapper} ${onUseTemplate ? style.template_selection_heading : ''}`}>
      {/* <EditableText
        title={title}
        handleSubmitTitle={handleSubmitTitle}
        hideEditButton={hideEditButton}
        defaultEditMode={projectBoardId === 'NEW'}
      /> */}
      {!isMasterCalender && !isGeneralPreview && !onUseTemplate && (
        <div
          className="preMenu"
          onClick={() => {
            if (boardViewType === 'calendar') {
              parentRef?.current?.toggleWeekends?.();
              return;
            }
            toggleBoardList();
          }}>
          <img src={submenuIcon} alt="submenuIcon" className={`subMenuIcon ${isBoardListCollapsed ? 'rotated' : ''}`} />
        </div>
      )}
      {!isGeneralPreview ? (
        <div
          className="calender-body
  new-calender-body">
          {/* <div className="cal-strip"> */}
          <div className="cal-header" style={{ justifyContent: isMasterCalender ? 'flex-start' : '' }}>
            <div
              className={`seg-left ${showInput ? 'center-aligned' : ''}`}
              aria-label="View type"
              role="tablist"
              style={{ width: showInput ? '100%' : '40%' }}>
              {!isTemplateActive && (
                <>
                  {!showInput && !hideTabs && (
                    <>
                      {isProjectRelatedBoard && (
                        <button
                          className={`${boardViewType === 'overview' ? '' : 'is-active'} btn `}
                          role="tab"
                          aria-selected={boardViewType === 'overview'}
                          onClick={() => setBoardViewType('overview')}>
                          <img src={OverviewIcon} alt="Overview" className="overview-icon" />
                          Overview
                        </button>
                      )}
                      {!isMasterCalender && (
                        <button
                          className={`${boardViewType === 'board' ? '' : 'is-active'} btn `}
                          role="tab"
                          aria-selected={boardViewType === 'board'}
                          onClick={() => setBoardViewType('board')}>
                          <img src={Board} alt="Board" className="board" />
                          Board
                        </button>
                      )}
                      <button
                        className={`${boardViewType === 'calendar' ? '' : 'is-active'} btn `}
                        role="tab"
                        aria-selected={boardViewType === 'calendar'}
                        onClick={() => setBoardViewType('calendar')}>
                        <img src={Calender} alt="Calender" className="calender" />
                        Calendar
                      </button>
                    </>
                  )}
                  {/* <div> */}
                  {!isArchivedActive && (
                    <div
                      className={`${style.search_box_wrapper} ${showInput ? style.show : ''} ${
                        showInput ? '' : style.show_hover
                      }`}
                      onClick={!showInput ? () => handleIconClick(true) : undefined}>
                      {showInput && (
                        <input
                          ref={inputRef}
                          // type="search"

                          id="search-box-tour"
                          placeholder="Search tasks..."
                          value={searchValue}
                          onChange={handleSearchChange}
                        />
                      )}
                      {/* {!searchValue && ( */}
                      <img
                        src={searchIcon}
                        alt="search-icon"
                        onClick={() => handleIconClick(true)}
                        className={`${style.search_icon} cursor_pointer`}
                      />
                      {/* )} */}
                      {showInput && (
                        <img
                          src={closeIcon}
                          alt="search-icon"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleIconClick(false);
                            setSearchValue('');
                          }}
                          className={`cursor_pointer`}
                        />
                      )}
                    </div>
                  )}
                  {/* </div> */}
                </>
              )}
            </div>

            {boardViewType === 'calendar' && !showInput ? (
              <>
                <div className="cal-title">
                  <div className="bgarrow cursor_pointer" onClick={() => parentRef.current.goPrev()}>
                    <img src={ArrowLeft} alt="Calender" className="ArrowLeft " />
                  </div>
                  {calendarTitle}
                  <div className="bgarrow cursor_pointer" onClick={() => parentRef.current.goNext()}>
                    <img src={ArrowRight} alt="Calender" className="ArrowRight " />
                  </div>
                </div>
                {/* {isMasterCalender && !isGoogleCalendarConnected && (
                  <button
                    type="button"
                    className={`${style.google_calendar_export} btn`}
                    onClick={handleGoogleCalendarExport}
                    disabled={isGoogleExporting}>
                    {isGoogleExporting ? (
                      selectLoader(18)
                    ) : (
                      <>
                        <span className={style.google_calendar_icon} aria-hidden="true">
                          G
                        </span>
                        Connect Google Calendar
                      </>
                    )}
                  </button>
                )} */}
                {isMasterCalender && isGoogleCalendarConnected && (
                  <button
                    type="button"
                    className={`${style.google_calendar_disconnect} btn`}
                    onClick={handleGoogleCalendarDisconnect}
                    disabled={isGoogleDisconnecting}>
                    {isGoogleDisconnecting ? selectLoader(18) : 'Disconnect Google'}
                  </button>
                )}
                <div className="seg-right" aria-label="Calendar range" role="tablist">
                  <button
                    example-custom-input
                    onClick={() => setCalenderViewType('dayGridMonth')}
                    className={`${calenderViewType === 'dayGridMonth' ? 'is-active' : ''} btn  `}
                    role="tab"
                    aria-selected={calenderViewType === 'dayGridMonth'}
                    title={'Month'}>
                    M
                  </button>
                  <button
                    onClick={() => setCalenderViewType('timeGridWeek')}
                    className={`${calenderViewType === 'timeGridWeek' ? 'is-active' : ''} btn `}
                    role="tab"
                    aria-selected={calenderViewType === 'timeGridWeek'}
                    title={'Week'}>
                    W
                  </button>
                  <button
                    onClick={() => setCalenderViewType('timeGridDay')}
                    className={`${calenderViewType === 'timeGridDay' ? 'is-active' : ''} btn `}
                    role="tab"
                    aria-selected={calenderViewType === 'timeGridDay'}
                    title={'Day'}>
                    D
                  </button>
                </div>
              </>
            ) : // <></>
            isArchivedActive ? (
              <div className="board-item-right" onClick={() => setShowConfirm(true)}>
                <img src={Archived} alt="archived-icon" className="archived-icon" />
                {isSaving ? selectLoader(20) : isArchivedActive ? 'Restore' : 'Archive'}
              </div>
            ) : (
              <></>
            )}
          </div>
          {/* </div> */}
        </div>
      ) : (
        <div className={`${isTemplateActive ? '' : 'ml-3'}`} style={{ flex: isTemplateActive ? 'auto' : 'inherit' }}>
          <EditableText
            title={title}
            handleSubmitTitle={handleSubmitTitle}
            hideEditButton={hideEditButton}
            defaultEditMode={projectBoardId === 'NEW'}
          />
        </div>
      )}
      {isTemplateActive ? (
        <div
          className={`${style.search_and_invite_wrapper} ${style.button_use_template}`}
          style={{ flex: 'auto', justifyContent: 'end' }}>
          <div className="d-flex gap-2 align-items-center justify-content-center" ref={targetRef}>
            <div>
              <button
                className="share-btn"
                disabled={isApplyingTemplate}
                onClick={handleUseTemplateClick}>
                {isApplyingTemplate ? selectLoader(22) : 'Use this template'}
              </button>
            </div>
            <Dropdown align="end" className={style.template_actions_dropdown}>
              <Dropdown.Toggle
                className={style.template_actions_toggle}
                aria-label="Template actions"
                title="Template actions">
                <img src={dotsThreeIcon} alt="" aria-hidden="true" />
              </Dropdown.Toggle>
              <Dropdown.Menu className={style.template_actions_menu}>
                <Dropdown.Item className={style.template_action_item} onClick={openTemplateEdit}>
                  <img src={editIcon} alt="" aria-hidden="true" />
                  Edit name
                </Dropdown.Item>
                <Dropdown.Item
                  className={`${style.template_action_item} ${style.template_delete_action}`}
                  onClick={() => setShowTemplateDelete(true)}>
                  <img src={deleteIcon} alt="" aria-hidden="true" />
                  Delete
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      ) : !isArchivedActive && !showInput ? (
        <div className={`${style.search_and_invite_wrapper} ${style.marginauto}`}>
          <div className="d-flex gap-2" ref={targetRef}>
            {/* <div className={style.user_save_cover}>
              <AvatarGroup
                members={teams}
                handleClick={() => {
                  setShow(false);
                  setShowMemberPopup(!showMembersPopup);
                }}
              />
              <button
                onClick={() => {
                  setSaveOpen(true);
                  setShow(false);
                  setShowMemberPopup(false);
                }}
                className={style.save_btn}>
                <img src={SaveIcon2} alt="SaveIcon2-icon" className="SaveIcon2" />
              </button>
            </div> */}
            <div>
              <FilterDropdown
                members={teams}
                priorityOptions={priorityOptions}
                dueDateOptions={dueDateOptions}
                milestones={milestones}
                setFilteredMilestones={setFilteredMilestones}
                isMasterCalender={isMasterCalender}
                boardLabels={defaultLabels}
                reloadMilestones={reloadMilestones}
                projectBoardId={projectBoardId}
                calendarEvents={calendarEvents}
                setFilteredCalendarEvents={setFilteredCalendarEvents}
                setshowArchivedCards={setshowArchivedCards}
              />
            </div>
            {!isMasterCalender && !isArchivedParent && (
              <div>
                <button
                  className="filter-menu"
                  onClick={() => {
                    setShowMemberPopup(false);
                    setShow(!show);
                  }}>
                  <img title={'Share'} src={ShareNetwork} className="filterMenu" alt="share-1" />
                </button>
              </div>
            )}
            {!isMasterCalender && !viewMode && (
              <div className={style.custom_drp}>
                <Dropdown className="head-humburg-cover">
                  <Dropdown.Toggle id="dropdown-custom-components" className="head-humburg-menu">
                    <img src={dotsMenu} alt="menu" />
                  </Dropdown.Toggle>

                  <Dropdown.Menu
                    className="p-3"
                    // className={style.dropdown_menu}
                    onClick={(e) => {
                      e.stopPropagation();
                    }}>
                    <div class="sec_title">More options</div>
                    {!isArchivedParent && (
                      <Dropdown.Item
                        eventKey="1"
                        onClick={() => {
                          setSaveOpen(true);
                          setShow(false);
                          setShowMemberPopup(false);
                        }}>
                        <img src={Save01} alt="menu" />
                        Save
                      </Dropdown.Item>
                    )}
                    <Dropdown.Item eventKey="2" onClick={() => setShowConfirm(true)}>
                      <img src={Close4} alt="menu" />
                      {isArchivedParent ? 'Restore' : 'Close'}
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            )}
          </div>
        </div>
      ) : (
        <></>
      )}
      {(show || showMembersPopup) && (
        <InviteMemberPopup
          target={targetRef}
          overlayRef={overlayRef}
          onClose={() => {
            setShow(false);
            setShowMemberPopup(false);
          }}
          show={show || showMembersPopup}
          members={teams}
          projectBoardId={projectBoardId}
          inviteTeam={inviteTeam}
          handleRemoveInvitee={handleRemoveInvitee}
          projectBoardCreatedBy={projectBoardCreatedBy}
          viewMode={viewMode}
          isInviting={isInviting}
          hideInvitee={showMembersPopup}
          title={showMembersPopup ? 'Manage Project Members' : 'Invite Member'}
          subtitle={
            showMembersPopup ? 'Set permissions for each team member' : 'Share your project collaborate with your team'
          }
        />
      )}
      <SaveModalKanban
        show={saveOpen}
        onHide={() => {
          setSaveOpen(false);
          setTemplateTitle('');
        }}
        isCreateBoard={isTemplateActive}
        onSave={isTemplateActive ? handleSaveBoardFromTemp : handleSaveTemplate}
        title={templateTitle}
        onTitleChange={setTemplateTitle}
        isLoading={savingTemplate}
      />
      <Modal
        show={showTemplateEdit}
        onHide={() => setShowTemplateEdit(false)}
        centered
        className="deletModal create-board-modal saved-template-edit-modal">
        <form onSubmit={handleTemplateRename}>
          <Modal.Header closeButton>
            <div className="modal-title">Edit Template</div>
          </Modal.Header>
          <Modal.Body className="save-templete-cover">
            <div className="save-templete-box">
              <label htmlFor="preview-template-name">Template name*</label>
              <input
                id="preview-template-name"
                type="text"
                className="form-control"
                value={editedTemplateName}
                maxLength={80}
                autoFocus
                onChange={(event) => setEditedTemplateName(event.target.value)}
                placeholder="Write template name"
              />
            </div>
            <div className="save-templete-group-btn">
              <button
                type="submit"
                className={`black-btn cursor_pointer ${!editedTemplateName.trim() ? 'disabled-btn' : ''}`}
                disabled={!editedTemplateName.trim()}>
                Save
              </button>
            </div>
          </Modal.Body>
        </form>
      </Modal>
      <DeleteModal
        show={showTemplateDelete}
        onHide={() => setShowTemplateDelete(false)}
        handleDelete={handleTemplateDelete}
        loading={false}
        itemName="template"
      />
    </div>
  );
};

export default ProjectBoardHeading;
